import {createContext} from 'react';

import {CulturalAnalysisPdf} from '../../features/company/pdf/types';
import {ApiResponseError} from '../../lib/api/v1/types';

interface CultureAnalysisPdfContextType {
  resourceId: string;
  downloadToken: string;
  language: string;
  loading: boolean;
  data?: CulturalAnalysisPdf;
  error?: ApiResponseError;
}

export const CultureAnalysisPdfContext = createContext<CultureAnalysisPdfContextType>(
  {} as CultureAnalysisPdfContextType
);
